import { JoinSqlConditionRow } from './DataModelerJoinUI';
import { TextAreaField } from '../../../../components/Form';
import React from 'react';

interface IProps {
  isAdvancedEditMode: boolean;
  sqlCondition: string | null;
  setSqlCondition: (sqlCondition: string | null) => void;
}

const DataModelerEditJoinSqlCondition = ({
  isAdvancedEditMode,
  sqlCondition,
  setSqlCondition,
}: IProps) => {
  if (!isAdvancedEditMode && !sqlCondition) {
    return null;
  }
  return (
    <JoinSqlConditionRow>
      <div>Custom SQL Condition:</div>
      <div>
        <TextAreaField
          value={sqlCondition ?? ''}
          onChange={setSqlCondition}
          minRows={1}
          maxRows={16}
          disabled={!isAdvancedEditMode}
        />
      </div>
    </JoinSqlConditionRow>
  );
};

export default DataModelerEditJoinSqlCondition;
